<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.userDetail") }}</h4>
    </div>
    <div class="brick_box">
      <table class="mgt_tbl mgb_0">
        <colgroup>
          <col style="width: 15%" />
          <col style="width: 35%" />
          <col style="width: 15%" />
          <col style="" />
        </colgroup>
        <tbody>
          <tr>
            <th>ID</th>
            <td v-if="this.$route.params.loginId == undefined" class="d-flex">
              <input
                type="text"
                v-model="mem.loginId"
                placeholder="email@email.com"
                class="int_type01 write_int w-50"
                v-validate="'required'"
              />
              <button class="btn btn-secondary btn-sm" @click="checkDuplicate">
                {{ $t("signup.checkForDuplicates") }}
              </button>
            </td>
            <td v-else>
              {{ mem.loginId }}
            </td>
            <th v-if="this.$route.params.loginId != undefined">
              {{ $t("management.usageStatus") }}
            </th>
            <th v-else>{{ $t("signup.password") }}</th>
            <td v-if="this.$route.params.loginId != undefined">
              {{
                mem.activeFlag == "1"
                  ? $t("management.approved")
                  : $t("management.disApproved")
              }}
            </td>
            <td v-else>
              <input
                type="password"
                class="int_type01 write_int"
                placeholder="숫자와 영문자 조합으로 8~16자리를 사용"
                name="password"
                v-model="mem.password"
                v-validate="'required'"
              />
            </td>
          </tr>
          <tr>
            <th><span class="required-star">*</span> {{ $t("common.name") }}</th>
            <td>
              <input
                type="text"
                class="int_type01 write_int"
                v-model="mem.userName"
                v-validate="'required'"
              />
            </td>
            <th>e-Mail</th>
            <td>{{ mem.emailAddress }}</td>
          </tr>
          <tr>
            <th>{{ $t("management.company") }}</th>
            <td>
              <input type="text" class="int_type01 write_int" v-model="mem.compName" />
            </td>
            <th>{{ $t("management.department") }}</th>
            <td>
              <input type="text" class="int_type01 write_int" v-model="mem.deptName" />
            </td>
          </tr>
          <tr>
            <th>{{ $t("management.countryName") }}</th>
            <td>
              <!-- {{ mem.countryName }} -->
              <select class="form-control" v-model="mem.countryCode">
                <option value="">--{{ $t("management.selectCountry") }}--</option>
                <option
                  v-for="(country, index) in countrys"
                  :key="index"
                  :value="country.codeId"
                >
                  {{ country.codeName }}
                </option>
              </select>
            </td>
            <!-- <th>{{ $t("management.position") }}</th>
            <td></td> -->
            <th><span class="required-star">*</span> {{ $t("management.userType") }}</th>
            <td>
              <select class="form-control" v-model="mem.userDiv" v-validate="'required'">
                <option value="1">{{ $t("management.employees") }}</option>
                <option value="2">{{ $t("management.dealer") }}</option>
                <option value="3">{{ $t("management.userRole") }}</option>
              </select>
              <!-- {{
                mem.userDiv == "1"
                  ? $t("management.employees")
                  : mem.userDiv == "2"
                  ? $t("management.dealer")
                  : $t("management.userRole")
              }} -->
            </td>
          </tr>
          <tr>
            <th>{{ $t("management.compTelNo") }}</th>
            <td>
              <input type="text" class="int_type01 write_int" v-model="mem.compTelNo" />
              <!-- {{ mem.compTelNo }} -->
            </td>
            <th>{{ $t("management.phoneNumber") }}</th>
            <td class="d-flex">
              <select class="form-control w-25" v-model="mem.mobileTelCountry">
                <option value="">선택안함</option>
                <option value="233">+233 가나</option>
                <option value="241">+241 가봉</option>
                <option value="592">+592 가이아나</option>
                <option value="220">+220 감비아</option>
                <option value="502">+502 과테말라</option>
                <option value="1671">+1 671 괌</option>
                <option value="1473">+1 473그레나다</option>
                <option value="30">+30 그리스</option>
                <option value="224">+224 기니</option>
                <option value="245">+245 기니비사우</option>
                <option value="264">+264 나미비아</option>
                <option value="674">+674 나우루</option>
                <option value="234">+234 나이지리아</option>
                <option value="672">+672 남극,오스트레일리아의외</option>
                <option value="27">+27 남아프리카공화국</option>
                <option value="31">+31 네덜란드</option>
                <option value="599">+599 네덜란드령보네르</option>
                <option value="297">+297 네덜란드령아루바</option>
                <option value="977">+977 네팔</option>
                <option value="47">+47 노르웨이</option>
                <option value="64">+64 뉴질랜드</option>
                <option value="683">+683 뉴질랜드령니우에</option>
                <option value="690">+690 뉴질랜드령토켈라우제도</option>
                <option value="227">+227 니제르</option>
                <option value="505">+505 니카라과</option>
                <option value="82">+82 대한민국</option>
                <option value="45">+45 덴마크</option>
                <option value="299">+299 덴마크령그린란드</option>
                <option value="298">+298 덴마크령페로제도</option>
                <option value="1809">+1 809 도미니카공화국</option>
                <option value="1829">+1 829 도미니카공화국 2</option>
                <option value="1849">+1 849 도미니카공화국 3</option>
                <option value="49">+49 독일</option>
                <option value="670">+670 동티모르</option>
                <option value="856">+856 라오스</option>
                <option value="231">+231 라이베리아</option>
                <option value="371">+371 라트비아</option>
                <option value="7">+7 러시아/카자흐스탄</option>
                <option value="961">+961 레바논</option>
                <option value="266">+266 레소토</option>
                <option value="40">+40 루마니아</option>
                <option value="352">+352 룩셈부르크</option>
                <option value="250">+250 르완다</option>
                <option value="218">+218 리비아</option>
                <option value="370">+370 리투아니아</option>
                <option value="423">+423 리히텐슈타인</option>
                <option value="261">+261 마다가스카르</option>
                <option value="692">+261 마셜제도공화국</option>
                <option value="691">+691 마이크로네시아연방</option>
                <option value="853">+853 마카오</option>
                <option value="389">+389 마케도니아공화국</option>
                <option value="265">+265 말라위</option>
                <option value="60">+60 말레이시아</option>
                <option value="223">+223 말리</option>
                <option value="52">+52 멕시코</option>
                <option value="377">+377 모나코</option>
                <option value="212">+212 모로코</option>
                <option value="230">+230 모리셔스</option>
                <option value="222">+222 모리타니아</option>
                <option value="258">+258 모잠비크</option>
                <option value="382">+382 몬테네그로</option>
                <option value="373">+373 몰도바</option>
                <option value="960">+960 몰디브</option>
                <option value="356">+356 몰타</option>
                <option value="976">+976 몽골</option>
                <option value="1">+1 미국/캐나다</option>
                <option value="1670">+1 670 미국령북마리아나제도</option>
                <option value="95">+95 미얀마</option>
                <option value="678">+678 바누아투</option>
                <option value="973">+973 바레인</option>
                <option value="1246">+1 246 바베이도스</option>
                <option value="1242">+1 242 바하마</option>
                <option value="880">+880 방글라데시</option>
                <option value="229">+229 베냉</option>
                <option value="58">+58 베네수엘라</option>
                <option value="84">+84 베트남</option>
                <option value="32">+32 벨기에</option>
                <option value="375">+375 벨라루스</option>
                <option value="501">+501 벨리즈</option>
                <option value="387">+387 보스니아헤르체고비나</option>
                <option value="267">+267 보츠와나</option>
                <option value="591">+591 볼리비아</option>
                <option value="257">+257 부룬디</option>
                <option value="226">+226 부르키나파소</option>
                <option value="975">+975 부탄</option>
                <option value="359">+359 불가리아</option>
                <option value="55">+55 브라질</option>
                <option value="673">+673 브루나이</option>
                <option value="685">+685 사모아</option>
                <option value="966">+966 사우디아라비아</option>
                <option value="378">+378 산마리노</option>
                <option value="239">+239 상투메프린시페</option>
                <option value="221">+221 세네갈</option>
                <option value="381">+381 세르비아</option>
                <option value="248">+248 세이셀</option>
                <option value="1784">+1 784 세인트빈센트그레나딘</option>
                <option value="252">+252 소말리아</option>
                <option value="677">+677 솔로몬제도</option>
                <option value="249">+249 수단</option>
                <option value="597">+597 수리남</option>
                <option value="94">+94 스리랑카</option>
                <option value="268">+268 스와질랜드</option>
                <option value="46">+46 스웨덴</option>
                <option value="41">+41 스위스</option>
                <option value="34">+34 스페인</option>
                <option value="421">+421 슬로바키아</option>
                <option value="386">+386 슬로베니아</option>
                <option value="963">+963 시리아</option>
                <option value="232">+232 시에라리온</option>
                <option value="65">+65 싱가포르</option>
                <option value="971">+971 아랍에미리트</option>
                <option value="374">+374 아르메니아</option>
                <option value="54">+54 아르헨티나</option>
                <option value="1684">+1 684 아메리칸사모아</option>
                <option value="354">+354 아이슬란드</option>
                <option value="509">+509 아이티</option>
                <option value="353">+353 아일랜드</option>
                <option value="994">+994 아제르바이잔</option>
                <option value="93">+93 아프가니스탄</option>
                <option value="376">+376 안도라</option>
                <option value="355">+355 알바니아</option>
                <option value="213">+213 알제리</option>
                <option value="244">+244 앙골라</option>
                <option value="251">+251 에디오피아</option>
                <option value="291">+291 에리트레아</option>
                <option value="372">+372 에스토니아</option>
                <option value="593">+593 에콰도르</option>
                <option value="503">+503 엘살바도르</option>
                <option value="44">+44 영국</option>
                <option value="290">+290 영국령세인트헬레나</option>
                <option value="246">+246 영국령인도양지역</option>
                <option value="350">+350 영국령지브롤터</option>
                <option value="500">+500 영국령포클랜드제도</option>
                <option value="967">+967 예멘</option>
                <option value="968">+968 오만</option>
                <option value="43">+43 오스트리아</option>
                <option value="504">+504 온두라스</option>
                <option value="962">+962 요르단</option>
                <option value="256">+256 우간다</option>
                <option value="598">+598 우루과이</option>
                <option value="998">+998 우즈베키스탄</option>
                <option value="380">+380 우크라이나</option>
                <option value="964">+964 이라크</option>
                <option value="98">+98 이란</option>
                <option value="972">+972 이스라엘</option>
                <option value="20">+20 이집트</option>
                <option value="39">+39 이탈리아</option>
                <option value="91">+91 인도</option>
                <option value="62">+62 인도네시아</option>
                <option value="81">+81 일본</option>
                <option value="1876">+1 876 자메이카</option>
                <option value="260">+260 잠비아</option>
                <option value="240">+240 적도기니</option>
                <option value="995">+995 조지아</option>
                <option value="86">+86 중국</option>
                <option value="236">+236 중앙아프리카공화국</option>
                <option value="253">+253 지부티</option>
                <option value="263">+263 짐바브웨</option>
                <option value="235">+235 차드</option>
                <option value="420">+420 체코</option>
                <option value="56">+56 칠레</option>
                <option value="237">+237 카메룬</option>
                <option value="238">+238 카보베르데</option>
                <option value="974">+974 카타르</option>
                <option value="855">+855 캄보디아왕국</option>
                <option value="254">+254 케냐</option>
                <option value="269">+269 코모로,마요트</option>
                <option value="506">+506 코스타리카</option>
                <option value="225">+225 코트디부아르</option>
                <option value="57">+57 콜롬비아</option>
                <option value="242">+242 콩고</option>
                <option value="243">+243 콩고민주공화국</option>
                <option value="53">+53 쿠바</option>
                <option value="965">+965 쿠웨이트</option>
                <option value="682">+682 쿡제도</option>
                <option value="385">+385 크로아티아</option>
                <option value="996">+996 키르기스스탄</option>
                <option value="686">+686 키리바시</option>
                <option value="357">+357 키프로스</option>
                <option value="886">+886 타이완</option>
                <option value="992">+992 타지키스탄</option>
                <option value="255">+255 탄자니아</option>
                <option value="66">+66 태국</option>
                <option value="90">+90 터키</option>
                <option value="228">+228 토고</option>
                <option value="676">+676 통가</option>
                <option value="993">+993 투르크메니스탄</option>
                <option value="216">+216 튀니지</option>
                <option value="1868">+1 868 트리니다드토바고</option>
                <option value="507">+507 파나마</option>
                <option value="595">+595 파라과이</option>
                <option value="92">+92 파키스탄</option>
                <option value="675">+675 파푸아뉴기니</option>
                <option value="680">+680 팔라우</option>
                <option value="970">+970 팔레스타인</option>
                <option value="51">+51 페루</option>
                <option value="351">+351 포르투갈</option>
                <option value="48">+48 폴란드</option>
                <option value="1787">+1 787 푸에르토리코</option>
                <option value="33">+33 프랑스</option>
                <option value="590">+590 프랑스령과들루프</option>
                <option value="594">+594 프랑스령기아나</option>
                <option value="687">+687 프랑스령뉴칼레도니아</option>
                <option value="262">+262 프랑스령레위니옹</option>
                <option value="596">+596 프랑스령마르티니크</option>
                <option value="508">+508 프랑스령생피에르미클롱</option>
                <option value="681">+681 프랑스령월리스푸투나제</option>
                <option value="689">+689 프랑스령폴리네시아</option>
                <option value="679">+679 피지</option>
                <option value="358">+358 핀란드</option>
                <option value="63">+63 필리핀</option>
                <option value="36">+36 헝가리</option>
                <option value="61">+61 호주</option>
                <option value="852">+852 홍콩</option>
              </select>
              <input
                type="text"
                class="int_type01 write_int"
                v-model="mem.mobileTelNo"
                placeholder="ex) 010-0000-0000"
                name="mobileTelNo"
              />
              <!-- {{ mem.mobileTelNo }} -->
            </td>
          </tr>
          <tr>
            <th>{{ $t("management.lastLoginDatetime") }}</th>
            <td>{{ mem.lastLoginDatetime }}</td>
            <th>{{ $t("management.modifyDatetime") }}</th>
            <td>{{ mem.lastModDatetime }}</td>
          </tr>
          <!-- <tr>
            <th>{{ $t("management.countryName") }}</th>
            <td colspan="3">{{ mem.countryName }}</td>
          </tr> -->
          <tr v-if="this.$route.params.loginId != undefined">
            <th>{{ $t("common.pdfWaterMark") }}</th>
            <td colspan="3">
              <input v-model="mem.pdfWatermarkYn" type="radio" value="Y" /><label
                style="margin-right: 10px"
                >{{ $t("common.yes") }}</label
              >
              <input v-model="mem.pdfWatermarkYn" type="radio" value="N" /><label>{{
                $t("common.no")
              }}</label>
            </td>
          </tr>
          <tr v-if="this.$route.params.loginId != undefined">
            <th>{{ $t("common.pdfView") }}</th>
            <td>
              <input v-model="mem.pdfViewYn" type="radio" value="Y" /><label
                style="margin-right: 10px"
                >{{ $t("common.yes") }}</label
              >
              <input v-model="mem.pdfViewYn" type="radio" value="N" /><label>{{
                $t("common.no")
              }}</label>
            </td>
            <th>
              <input
                v-model="mem.pdfViewPeriodYn"
                type="radio"
                value="N"
                :disabled="mem.pdfViewYn == 'N'"
              /><label style="margin-right: 10px">{{ $t("common.periodFull") }}</label
              ><br />
              <input
                v-model="mem.pdfViewPeriodYn"
                type="radio"
                value="Y"
                :disabled="mem.pdfViewYn == 'N'"
              /><label>{{ $t("common.periodSetting") }}</label>
            </th>
            <td class="d-flex" style="align-items: center">
              <b-form-datepicker
                v-model="mem.pdfViewStartDatetime"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                aria-controls="example-input"
                placeholder="YYYY-MM-DD"
                style="height: 35px; border-radius: 0px"
                label-no-date-selected=""
                :disabled="mem.pdfViewPeriodYn == 'N'"
              ></b-form-datepicker>
              ~
              <b-form-datepicker
                v-model="mem.pdfViewEndDatetime"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                aria-controls="example-input"
                placeholder="YYYY-MM-DD"
                style="height: 35px; border-radius: 0px"
                label-no-date-selected=""
                :disabled="mem.pdfViewPeriodYn == 'N'"
              ></b-form-datepicker>
            </td>
          </tr>
          <!-- <tr v-if="this.$route.params.loginId != undefined">
            <th>{{ $t("common.pdfDownload") }}</th>
            <td>
              <input v-model="mem.pdfDownloadYn" type="radio" value="Y" /><label
                style="margin-right: 10px"
                >{{ $t("common.yes") }}</label
              >
              <input v-model="mem.pdfDownloadYn" type="radio" value="N" /><label>{{
                $t("common.no")
              }}</label>
            </td>
            <th>
              <input
                v-model="mem.pdfDownloadPeriodYn"
                type="radio"
                value="N"
                :disabled="mem.pdfDownloadYn == 'N'"
              /><label style="margin-right: 10px">{{ $t("common.periodFull") }}</label
              ><br />
              <input
                v-model="mem.pdfDownloadPeriodYn"
                type="radio"
                value="Y"
                :disabled="mem.pdfDownloadYn == 'N'"
              /><label>{{ $t("common.periodSetting") }}</label>
            </th>
            <td class="d-flex" style="align-items: center">
              <b-form-datepicker
                v-model="mem.pdfDownloadStartDatetime"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                aria-controls="example-input"
                placeholder="YYYY-MM-DD"
                style="height: 35px; border-radius: 0px"
                label-no-date-selected=""
                :disabled="mem.pdfDownloadPeriodYn == 'N'"
              ></b-form-datepicker>
              ~
              <b-form-datepicker
                v-model="mem.pdfDownloadEndDatetime"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                aria-controls="example-input"
                placeholder="YYYY-MM-DD"
                style="height: 35px; border-radius: 0px"
                label-no-date-selected=""
                :disabled="mem.pdfDownloadPeriodYn == 'N'"
              ></b-form-datepicker>
            </td>
          </tr> -->
          <tr v-if="this.$route.params.loginId != undefined">
            <th>{{ $t("common.webhelpView") }}</th>
            <td>
              <input v-model="mem.webhelpViewYn" type="radio" value="Y" /><label
                style="margin-right: 10px"
                >{{ $t("common.yes") }}</label
              >
              <input v-model="mem.webhelpViewYn" type="radio" value="N" /><label>{{
                $t("common.no")
              }}</label>
            </td>
            <th>
              <input
                v-model="mem.webhelpViewPeriodYn"
                type="radio"
                value="N"
                :disabled="mem.webhelpViewYn == 'N'"
              /><label style="margin-right: 10px">{{ $t("common.periodFull") }}</label
              ><br />
              <input
                v-model="mem.webhelpViewPeriodYn"
                type="radio"
                value="Y"
                :disabled="mem.webhelpViewYn == 'N'"
              /><label>{{ $t("common.periodSetting") }}</label>
            </th>
            <td class="d-flex" style="align-items: center">
              <b-form-datepicker
                v-model="mem.webhelpViewStartDatetime"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                aria-controls="example-input"
                placeholder="YYYY-MM-DD"
                style="height: 35px; border-radius: 0px"
                label-no-date-selected=""
                :disabled="mem.webhelpViewPeriodYn == 'N'"
              ></b-form-datepicker>
              ~
              <b-form-datepicker
                v-model="mem.webhelpViewEndDatetime"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                aria-controls="example-input"
                placeholder="YYYY-MM-DD"
                style="height: 35px; border-radius: 0px"
                label-no-date-selected=""
                :disabled="mem.webhelpViewPeriodYn == 'N'"
              ></b-form-datepicker>
            </td>
          </tr>
          <tr v-if="this.$route.params.loginId != undefined">
            <th>{{ $t("common.webhelpDownload") }}</th>
            <td>
              <input v-model="mem.webhelpDownloadYn" type="radio" value="Y" /><label
                style="margin-right: 10px"
                >{{ $t("common.yes") }}</label
              >
              <input v-model="mem.webhelpDownloadYn" type="radio" value="N" /><label>{{
                $t("common.no")
              }}</label>
            </td>
            <th>
              <input
                v-model="mem.webhelpDownloadPeriodYn"
                type="radio"
                value="N"
                :disabled="mem.webhelpDownloadYn == 'N'"
              /><label style="margin-right: 10px">{{ $t("common.periodFull") }}</label
              ><br />
              <input
                v-model="mem.webhelpDownloadPeriodYn"
                type="radio"
                value="Y"
                :disabled="mem.webhelpDownloadYn == 'N'"
              /><label>{{ $t("common.periodSetting") }}</label>
            </th>
            <td class="d-flex" style="align-items: center">
              <b-form-datepicker
                v-model="mem.webhelpDownloadStartDatetime"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                aria-controls="example-input"
                placeholder="YYYY-MM-DD"
                style="height: 35px; border-radius: 0px"
                label-no-date-selected=""
                :disabled="mem.webhelpDownloadPeriodYn == 'N'"
              ></b-form-datepicker>
              ~
              <b-form-datepicker
                v-model="mem.webhelpDownloadEndDatetime"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                aria-controls="example-input"
                placeholder="YYYY-MM-DD"
                style="height: 35px; border-radius: 0px"
                label-no-date-selected=""
                :disabled="mem.webhelpDownloadPeriodYn == 'N'"
              ></b-form-datepicker>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="this.$route.params.loginId != undefined" class="bottom_bt_box">
        <button
          type="button"
          @click="saveUserDocumentauth"
          class="btn btn-outline-dark btn-sm m-1"
        >
          {{ $t("common.save") }}
        </button>
        <button
          v-if="mem.userDiv === '3'"
          type="button"
          @click="initPassword"
          class="btn btn-outline-dark btn-sm m-1"
        >
          {{ $t("management.passwordReset") }}
        </button>
        <button
          v-if="mem.activeFlag === '0'"
          type="button"
          @click="approveUser"
          class="btn btn-outline-dark btn-sm m-1"
        >
          {{ $t("management.approval") }}
        </button>
        <button
          v-if="mem.activeFlag === '1'"
          type="button"
          @click="disApproveUser"
          class="btn btn-outline-dark btn-sm m-1"
        >
          {{ $t("management.disApproval") }}
        </button>
        <button type="button" @click="deleteUser" class="btn btn-outline-dark btn-sm m-1">
          {{ $t("common.delete") }}
        </button>
      </div>
      <div v-else class="bottom_bt_box">
        <button
          type="button"
          @click="saveNewUser"
          class="btn btn-outline-dark btn-sm m-1"
        >
          {{ $t("common.save") }}
        </button>
      </div>
    </div>
    <!----------------------------     문서권한허용    ----------------------------------------------------------------------------->
    <div class="allowDoc">
      <div class="management_top_box">
        <h4>{{ $t("management.allowDocumentAuthority") }}</h4>
      </div>
      <div class="brick_box">
        <div class="bt_sm_box" v-if="authAll == false">
          <button type="button" @click="saveNewAuth" class="btn btn-primary btn_sm">
            {{ $t("common.save") }}
          </button>
        </div>
        <table class="mgt_tbl">
          <colgroup>
            <col style="width: 200px" />
            <col style="" />
          </colgroup>
          <tbody v-if="authAll == false">
            <!------------------------------ Product------------------------------------------------->
            <tr>
              <th>
                <div class="tbl_add_th">
                  <em>{{ $t("management.product") }}</em>
                  <button
                    data-v-6c476327=""
                    type="button"
                    v-if="authProdAll"
                    @click="addAuth('product')"
                    class="tbl_add_bt"
                  >
                    {{ $t("common.add") }}
                  </button>
                </div>
              </th>
              <td>
                <div
                  v-for="(prod, index) in authProdList"
                  :key="index"
                  class="document_keyword"
                  :id="'p' + prod.authValue"
                >
                  {{ prod.authName }}
                  <button
                    type="button"
                    @click="[deleteProdAuth(prod, index), (authProdAll = true)]"
                    class="btn"
                  >
                    {{ $t("common.delete") }}
                  </button>
                </div>
              </td>
            </tr>
            <!------------------------------ Document Type------------------------------------------------->
            <tr>
              <th>
                <div class="tbl_add_th">
                  <em>{{ $t("management.documentType") }}</em>
                  <button
                    data-v-6c476327=""
                    v-if="authDocTypeAll"
                    @click="addAuth('documentType')"
                    type="button"
                    class="tbl_add_bt"
                  >
                    {{ $t("common.add") }}
                  </button>
                </div>
              </th>
              <td>
                <div
                  v-for="(doc, index) in authDocTypeList"
                  :key="index"
                  class="document_keyword"
                  :id="'dt' + doc.authValue"
                >
                  {{ doc.authName }}
                  <button
                    type="button"
                    @click="[deleteDocTypeAuth(doc, index), (authDocTypeAll = true)]"
                    class="btn"
                  >
                    {{ $t("common.delete") }}
                  </button>
                </div>
              </td>
            </tr>
            <!------------------------------ Exhaust Certification------------------------------------------------->
            <tr>
              <th>
                <div class="tbl_add_th">
                  <em>{{ $t("management.exhaustCertification") }}</em>
                  <button
                    data-v-6c476327=""
                    v-if="authExhaustAll"
                    @click="addAuth('exhaust')"
                    type="button"
                    class="tbl_add_bt"
                  >
                    {{ $t("common.add") }}
                  </button>
                </div>
              </th>
              <td>
                <div
                  v-for="(ex, index) in authExhaustList"
                  :key="index"
                  class="document_keyword"
                  :id="'e' + ex.authValue"
                >
                  {{ ex.authName }}
                  <button
                    type="button"
                    @click="[deleteExhaustAuth(ex, index), (authExhaustAll = true)]"
                    class="btn"
                  >
                    {{ $t("common.delete") }}
                  </button>
                </div>
              </td>
            </tr>
            <!------------------------------ Document------------------------------------------------->
            <!-- <tr>
              <th>
                <div class="tbl_add_th">
                  <em>{{ $t("management.document") }}</em>
                  <button
                    data-v-6c476327=""
                    v-if="authDocumentAll"
                    @click="addAuth('document')"
                    type="button"
                    class="tbl_add_bt"
                  >
                    {{ $t("common.add") }}
                  </button>
                </div>
              </th>
              <td>
                <div
                  v-for="(doc, index) in authDocumentList"
                  :key="index"
                  class="document_keyword"
                  :id="'d' + doc.authValue"
                >
                  {{ doc.authName }}
                  <button
                    type="button"
                    @click="[deleteDocumentAuth(doc, index), (authDocumentAll = true)]"
                    class="btn"
                  >
                    {{ $t("common.delete") }}
                  </button>
                </div>
              </td>
            </tr> -->
            <!------------------------------ Model ------------------------------------------------->
            <tr>
              <th>
                <div class="tbl_add_th">
                  <em>{{ $t("management.model") }}</em>
                  <button
                    data-v-6c476327=""
                    v-if="authModelAll"
                    @click="addAuth('model')"
                    type="button"
                    class="tbl_add_bt"
                  >
                    {{ $t("common.add") }}
                  </button>
                </div>
              </th>
              <td>
                <div
                  v-for="(model, index) in authModelList"
                  :key="index"
                  class="document_keyword"
                  :id="'m' + model.authValue"
                >
                  {{ model.authName }}
                  <button
                    type="button"
                    @click="[deleteModelAuth(model, index), (authModelAll = true)]"
                    class="btn"
                  >
                    {{ $t("common.delete") }}
                  </button>
                </div>
              </td>
            </tr>

            <!--------------------------------------------------------------------------------->
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="2" style="height: 5px">
                {{ $t("management.allowAllDocuments") }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!--------------------------------- Document PDF Download 권한  --------------------------------------->
  <div class="allowDocDown">
      <div class="management_top_box">
        <h4>Document Download Authority</h4>
      </div>
      <div class="brick_box">
        <div class="bt_box">
          <button
              data-v-6c476327=""
              type="button"
              v-if="authDocumentDownloadAll"
              @click="addDocDownloadAuthModal()"
              class="tbl_add_bt auth_btn" 
            >
              {{ $t("common.add") }}
          </button>
          <button type="button" @click="saveNewDownloadAuth" class="btn btn-primary btn_sm">
            {{ $t("common.save") }}
          </button>
        </div>
        <div style="overflow: auto; height: 400px;padding:10px;">
          <table class="mgt_tbl">
            <colgroup>
              <col style="20%" />
              <col style="15%" />
              <col style="65%" />
            </colgroup>
            <tbody>
              <tr v-for="(doc, index) in authPDFDownalodList"
                    :key="index"
                    :id="'d' + doc.docId">
                    <td v-if="doc.modelName != 'None' && doc.modelName != null && doc.modelName" style="width:50%;">
                      [{{doc.modelName}}] {{ doc.docTitle }}
                    </td>
                    <td v-else>
                      {{ doc.docTitle }}
                    </td>
                    <th style="width:15%;">
                      <label for="fullPeriod"><input type="radio" v-model="doc.periodYn" id="fullPeriod" value="N" checked> Full Period</label>
                      <br>
                      <label for="SetPeriod"><input type="radio" v-model="doc.periodYn" id="SetPeriod" value="Y"> Period Setting</label>
                    </th>
                    <td style="width:30%;">
                      <div style="display:flex;">
                      <b-form-datepicker
                        v-model="doc.startDatetime"
                        :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                        aria-controls="example-input"
                        placeholder="YYYY-MM-DD"
                        style="height: 35px; width:170px; border-radius: 0px"
                        label-no-date-selected=""
                        :disabled="doc.periodYn == 'N'"
                      ></b-form-datepicker>
                      ~ 
                      <b-form-datepicker
                        v-model="doc.endDatetime"
                        :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                        aria-controls="example-input"
                        placeholder="YYYY-MM-DD"
                        style="height: 35px; width:170px; border-radius: 0px"
                        label-no-date-selected=""
                        :disabled="doc.periodYn == 'N'"
                      ></b-form-datepicker>
                      </div>
                    </td>
                    <td style="width:5%;">
                      <button
                        type="button"
                        @click="[deleteDocDownloadAuth(doc, index), (authDocumentDownloadAll = true)]"
                        class="btn sm_delete"
                      >
                        {{ $t("common.delete") }}
                      </button>
                    </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
  </div>

    <!-----------------------------------  목록  ---------------------------------------->

    <div class="list_bottom_bt">
      <div class="float-end">
        <router-link to="/management/user" class="btn btn-outline-dark btn-lg">{{
          $t("common.list")
        }}</router-link>
      </div>
    </div>
    <!----------------------------------------     모달        -------------------------------------------------------------->
    <!---------------------------------------New Prod Auth ------------------------------------------------------------------>
    <CommonModal id="prodModal" v-if="showProdModal" @close="showProdModal == false">
      <template slot="header">
        <h3>{{ $t("management.addProdAuth") }}</h3>
      </template>
      <template slot="body">
        <div class="row">
          <div class="col-md-12 col-lg-4 col-xl-12 col-xxl-4">
            <div class="mgt_group_box">
              <div class="mgt_group_title">
                <h4>{{ $t("management.mainCategory") }}</h4>
              </div>
              <div class="mgt_list">
                <ul>
                  <li :id="item.prodId" v-for="(item, index) in productList" :key="index">
                    <a
                      href="javascript:void(0)"
                      @click="getSubProd(item.prodId)"
                      style="padding: 2px 17px 2px 17px"
                    >
                      <input
                        type="checkbox"
                        v-model="item.selected"
                        @click="resetProdSubList(item.prodName, item.selected)"
                        class="facet_chk p-2"
                        :disabled="prodDisabled"
                      />
                      {{ item.prodName }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div id="prodSub" class="col-md-12 col-lg-4 col-xl-12 col-xxl-4">
            <div class="mgt_group_box">
              <div class="mgt_group_title">
                <h4>{{ $t("management.subCategory") }}</h4>
              </div>
              <div class="mgt_list">
                <ul>
                  <li v-for="(item, index) in prodSubNewList" :key="index">
                    <a href="javascript:void(0)" style="padding: 2px 17px 2px 17px">
                      <input
                        type="checkbox"
                        v-model="item.selected"
                        class="facet_chk p-2"
                      />
                      {{ item.prodName }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button type="button" @click="getNewProdAuth" class="btn btn-primary">
          {{ $t("common.choose") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </CommonModal>
    <!---------------------------------------New DocType Auth ------------------------------------------------------------------>
    <CommonModal id="docModal" v-if="showDocModal" @close="showDocModal == false">
      <template slot="header">
        <h3>{{ $t("management.addDocTypeAuth") }}</h3>
      </template>
      <template slot="body">
        <div class="row">
          <div class="col-md-12 col-lg-4 col-xl-12 col-xxl-4">
            <div class="mgt_group_box">
              <div class="mgt_group_title">
                <h4>{{ $t("management.mainCategory") }}</h4>
              </div>
              <div class="mgt_list">
                <ul>
                  <li
                    :id="item.doctypeId"
                    v-for="(item, index) in docTypeList"
                    :key="index"
                  >
                    <a href="javascript:void(0)">
                      <input
                        type="checkbox"
                        v-model="item.selected"
                        class="facet_chk p-2"
                        @click="resetDocTypeList(item.doctypeName, item.selected)"
                      />
                      {{ item.doctypeName }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button type="button" @click="getNewDocTypeAuth" class="btn btn-primary">
          {{ $t("common.choose") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </CommonModal>

    <!---------------------------------------New ExhuastCertification Auth ------------------------------------------------------------------>
    <CommonModal id="exModal" v-if="showExModal" @close="showExModal == false">
      <template slot="header">
        <h3>{{ $t("management.addExhaustCertyAuth") }}</h3>
      </template>
      <template slot="body">
        <div class="row">
          <div class="col-md-12 col-lg-4 col-xl-12 col-xxl-4">
            <div class="mgt_group_box">
              <div class="mgt_group_title">
                <h4>{{ $t("management.mainCategory") }}</h4>
              </div>
              <div class="mgt_list">
                <ul>
                  <li
                    v-for="(item, index) in exList"
                    :id="item.exhaustCertiId"
                    :key="index"
                  >
                    <a href="javascript:void(0)">
                      <input
                        type="checkbox"
                        v-model="item.selected"
                        class="facet_chk p-2"
                        @click="
                          resetExhaustCertiList(item.exhaustCertiName, item.selected)
                        "
                      />
                      {{ item.exhaustCertiName }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button type="button" @click="getNewExhauseAuth" class="btn btn-primary">
          {{ $t("common.choose") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </CommonModal>

    <!---------------------------------------New Document Auth ------------------------------------------------------------------>
    <!-- <CommonModal id="docuModal" v-if="showDocuModal" @close="showDocuModal == false">
      <template slot="header">
        <h3>{{ $t("management.addDocumentAuth") }}</h3>
      </template>
      <template slot="body">
        <div style="overflow: auto; height: 500px">
          <div class="m-2">
            <table class="mgt_tbl mgb_0">
              <tbody>
                <tr>
                  <th>{{ $t("management.documentType") }}</th>
                  <td colspan="6">
                    <ul class="group_sel_ul">
                      <li>
                        <select
                          v-model="docForm.docTypeId"
                          class="int_type01 mgt_seltype"
                        >
                          <option value="">--{{ $t("common.all") }}--</option>
                          <option
                            v-for="(doc, index) in docTypeList"
                            :key="index"
                            :value="doc.doctypeId"
                          >
                            {{ doc.doctypeName }}
                          </option>
                        </select>
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <th>{{ $t("management.productType") }}</th>
                  <td colspan="6">
                    <ul class="group_sel_ul">
                      <li>
                        <em>{{ $t("management.mainCategory") }}</em>
                        <select
                          v-model="docForm.upperProdId"
                          class="int_type01 mgt_seltype"
                          @change="getSubProducts(docForm.upperProdId)"
                        >
                          <option value="">--{{ $t("common.all") }}--</option>
                          <option
                            v-for="(prod, index) in mainProd"
                            :key="index"
                            :value="prod.prodId"
                          >
                            {{ prod.prodName }}
                          </option>
                        </select>
                      </li>
                      <li>
                        <em>{{ $t("management.subCategory") }}</em>
                        <select v-model="docForm.prodId" class="int_type01 mgt_seltype">
                          <option value="">--{{ $t("common.all") }}--</option>
                          <option
                            v-for="(subProd, index) in subProductType"
                            :key="index"
                            :value="subProd.prodId"
                          >
                            {{ subProd.prodName }}
                          </option>
                        </select>
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <th>{{ $t("common.language") }}</th>
                  <td>
                    <select v-model="docForm.lang" class="int_type01 mgt_seltype">
                      <option value="">--{{ $t("common.all") }}--</option>
                      <option
                        v-for="(lang, index) in langList"
                        :key="index"
                        :value="lang.codeId"
                      >
                        {{ lang.codeName }}
                      </option>
                    </select>
                  </td>
                  <th>{{ $t("common.date") }}</th>
                  <td colspan="4">
                    <input
                      type="date"
                      class="int_type01 mgt_seltype"
                      v-model="docForm.startDate"
                      title="작성일"
                    />
                    ~
                    <input
                      type="date"
                      class="int_type01 mgt_seltype"
                      v-model="docForm.endDate"
                      title="작성일"
                    />
                  </td>
                </tr>
                <tr>
                  <th>{{ $t("common.documentName") }}</th>
                  <td colspan="5">
                    <input
                      type="text"
                      v-model="docForm.searchWord"
                      class="int_type01 mgt_seltype"
                      title="Search Document Name"
                      style="width: 100%"
                    />
                  </td>
                  <td style="text-align: right">
                    <button @click="searchDocBtn" class="btn btn-primary">
                      {{ $t("common.search") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <table class="list_tbl">
              <thead>
                <tr>
                  <th class="mobile_h">
                    <input
                      type="checkbox"
                      @click="resetDocumentList('All', docCheckAll)"
                      v-model="docCheckAll"
                    />
                  </th>
                  <th class="mobile_row">
                    {{ $t("product.documentType")
                    }}<span class="mobile_vt"
                      >/ {{ $t("support.notice.classify") }} /
                      {{ $t("support.notice.writer") }} /
                      {{ $t("support.notice.date") }} /
                      {{ $t("support.notice.file") }}</span
                    >
                  </th>
                  <th class="mobile_h">{{ $t("product.docTitle") }}</th>
                  <th class="mobile_h">{{ $t("product.distribute") }}</th>
                  <th class="mobile_h">{{ $t("common.language") }}</th>
                  <th class="mobile_h">{{ $t("support.notice.date") }}</th>
                </tr>
              </thead>
              <tbody v-if="documentList.length != 0">
                <tr
                  :id="item.docId + item.modelcodeId"
                  v-for="(item, index) in documentList"
                  :key="index"
                >
                  <td>
                    <input
                      type="checkbox"
                      v-model="item.selected"
                      class="form-check-input"
                      @click="resetDocumentList(item.docTitle, item.selected)"
                    />
                  </td>
                  <td class="text-left">{{ item.doctypeName }}</td>
                  <td class="text-left">
                    <router-link
                      :to="{ name: 'mgmtDocumentDtails', params: { docId: item.docId } }"
                      >{{ item.docTitle }}</router-link
                    >
                  </td>
                  <td v-if="item.publishedYn == 'Y'">{{ $t("product.distribute") }}</td>
                  <td v-else>{{ $t("product.unDistribute") }}</td>
                  <td>{{ item.lang }}</td>
                  <td>{{ item.firstRegDatetime | moment("YYYY-MM-DD") }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="5">{{ $t("common.noData") }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button type="button" @click="getNewDocumentAuth" class="btn btn-primary">
          {{ $t("common.choose") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </CommonModal> -->

     <!---------------------------------------Document Download Auth ------------------------------------------------------------------>
    <DocumentModal id="docDownloadModal" v-if="showDocDownloadModal" @close="showDocDownloadModal == false">
      <template slot="header">
        <h3>{{ $t("management.addDocumentAuth") }}</h3>
      </template>
      <template slot="body">
        <div>
          <!--검색--->
          <div class="m-2">
            <table class="mgt_tbl mgb_0">
              <tbody>
                <tr>
                  <th>{{ $t("management.documentType") }}</th>
                  <td colspan="6">
                    <ul class="group_sel_ul">
                      <li>
                        <select
                          v-model="docForm.doctypeId"
                          class="int_type01 mgt_seltype"
                        >
                          <option value="">--{{ $t("common.all") }}--</option>
                          <option
                            v-for="(doc, index) in docTypeList"
                            :key="index"
                            :value="doc.doctypeId"
                          >
                            {{ doc.doctypeName }}
                          </option>
                        </select>
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <th>{{ $t("management.productType") }}</th>
                  <td colspan="6">
                    <ul class="group_sel_ul">
                      <li>
                        <em>{{ $t("management.mainCategory") }}</em>
                        <select
                          v-model="docForm.upperProdId"
                          class="int_type01 mgt_seltype"
                          @change="getSubProducts(docForm.upperProdId)"
                        >
                          <option value="">--{{ $t("common.all") }}--</option>
                          <option
                            v-for="(prod, index) in mainProd"
                            :key="index"
                            :value="prod.prodId"
                          >
                            {{ prod.prodName }}
                          </option>
                        </select>
                      </li>
                      <li>
                        <em>{{ $t("management.subCategory") }}</em>
                        <select v-model="docForm.prodId" class="int_type01 mgt_seltype">
                          <option value="">--{{ $t("common.all") }}--</option>
                          <option
                            v-for="(subProd, index) in subProductType"
                            :key="index"
                            :value="subProd.prodId"
                          >
                            {{ subProd.prodName }}
                          </option>
                        </select>
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <th>{{ $t("common.language") }}</th>
                  <td>
                    <select v-model="docForm.lang" class="int_type01 mgt_seltype">
                      <option value="">--{{ $t("common.all") }}--</option>
                      <option
                        v-for="(lang, index) in langList"
                        :key="index"
                        :value="lang.codeId"
                      >
                        {{ lang.codeName }}
                      </option>
                    </select>
                  </td>
                  <th>{{ $t("common.date") }}</th>
                  <td colspan="4">
                    <input
                      type="date"
                      class="int_type01 mgt_seltype"
                      v-model="docForm.startDate"
                      title="작성일"
                    />
                    ~
                    <input
                      type="date"
                      class="int_type01 mgt_seltype"
                      v-model="docForm.endDate"
                      title="작성일"
                    />
                  </td>
                </tr>
                <tr>
                  <th>{{ $t("common.documentName") }}</th>
                  <td colspan="5">
                    <input
                      type="text"
                      v-model="docForm.searchWord"
                      class="int_type01 mgt_seltype"
                      title="Search Document Name"
                      style="width: 100%"
                    />
                  </td>
                  <td style="text-align: right">
                    <button @click="searchDocBtn" class="btn btn-primary">
                      {{ $t("common.search") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style="overflow: auto; height: 350px">
            <table class="list_tbl">
              <thead>
                <tr>
                  <!-- @click="goDocCheckAll($event.target.checked)" -->
                  <th class="mobile_h">
                    <input
                      type="checkbox"
                      @click="resetDocumentList('All', docCheckAll)"
                      v-model="docCheckAll"
                    />
                  </th>
                  <th class="mobile_row">
                    {{ $t("product.documentType")
                    }}<span class="mobile_vt"
                      >/ {{ $t("support.notice.classify") }} /
                      {{ $t("support.notice.writer") }} /
                      {{ $t("support.notice.date") }} /
                      {{ $t("support.notice.file") }}</span
                    >
                  </th>
                  <th class="mobile_h">{{ $t("product.docTitle") }}</th>
                  <th class="mobile_h">{{ $t("product.distribute") }}</th>
                  <th class="mobile_h">{{ $t("common.language") }}</th>
                  <th class="mobile_h">{{ $t("support.notice.date") }}</th>
                </tr>
              </thead>
              <tbody v-if="documentList.length != 0">
                <tr
                  :id="item.docId + item.modelcodeId"
                  v-for="(item, index) in documentList"
                  :key="index"
                >
                  <td>
                    <input
                      type="checkbox"
                      v-model="item.selected"
                      class="form-check-input"
                      @click="resetDocumentList(item.docTitle, item.selected)"
                    />
                  </td>
                  <td class="text-left">{{ item.doctypeName }}</td>
                  <td class="text-left" v-if="item.modelName != 'None'">
                    <router-link
                      :to="{ name: 'mgmtDocumentDtails', params: { docId: item.docId } }"
                      ><span v-if="item.modelName != null">[{{ item.modelName }}]</span> {{ item.docTitle }}</router-link
                    >
                  </td>
                  <td class="text-left" v-else>
                    <router-link
                      :to="{ name: 'mgmtDocumentDtails', params: { docId: item.docId} }"
                      >{{ item.docTitle }}</router-link
                    >
                  </td>   
                  <!-- <td class="text-left">
                    <router-link
                      :to="{ name: 'mgmtDocumentDtails', params: { docId: item.docId } }"
                      >{{ item.docTitle }}</router-link
                    >
                  </td> -->
                  <td v-if="item.publishedYn == 'Y'">{{ $t("product.distribute") }}</td>
                  <td v-else>{{ $t("product.unDistribute") }}</td>
                  <td>{{ item.lang }}</td>
                  <td>{{ item.firstRegDatetime | moment("YYYY-MM-DD") }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="5">{{ $t("common.noData") }}</td>
                </tr>
              </tbody>
            </table>
            <div v-if="documentList.length != 0" class="paging_nav">
              <div class="paging_nav">
                <a
                  href="javascript:void(0)"
                  v-if="pagingVO.startPage <= pagingVO.blockSize"
                  class="page_select prev_page disabled"
                  >이전페이지 이동</a
                >
                <a
                  v-else
                  href="javascript:void(0)"
                  class="page_select prev_page"
                  @click="searchPage(pagingVO.startPage - pagingVO.blockSize)"
                  v-bind:data-page="pagingVO.startPage - pagingVO.blockSize"
                  >이전페이지 이동</a
                >
                <span
                  v-for="(pages, index) in pagingVO.endPage - pagingVO.startPage + 1"
                  :key="index"
                >
                  <strong v-if="pagingVO.startPage + index == pagingVO.currentPage">{{
                    pagingVO.startPage + index
                  }}</strong>
                  <a href="javascript:void(0)" v-else @click="searchPage(pagingVO.startPage + index)">{{
                    pagingVO.startPage + index
                  }}</a>
                </span>
                <a
                  v-if="pagingVO.endPage >= pagingVO.totalPage"
                  href="javascript:void(0)"
                  class="page_select next_page disabled"
                  >다음페이지 이동</a
                >
                <a
                  v-else
                  href="javascript:void(0)"
                  @click="searchPage(pagingVO.endPage + 1)"
                  v-bind:data-page="pagingVO.endPage + 1"
                  class="page_select next_page"
                  >다음페이지 이동</a
                >
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button type="button" @click="getNewDocumentDownloadAuth" class="btn btn-primary">
          {{ $t("common.choose") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </DocumentModal>

    <!---------------------------------------New Model Auth ------------------------------------------------------------------>
    <NewModelModal id="modelModal" v-if="showModelModal" @close="showModelModal == false">
      <template slot="header">
        <h3>{{ $t("management.addModelAuth") }}</h3>
      </template>
      <template slot="body">
        <div class="row">
          <div class="m-2">
            <label for="allCheckbox"
              ><input
                type="checkbox"
                id="allCheckbox"
                v-model="modelAllCheckbox"
                @change="goCheckModelAll($event.target.checked)"
                name="all"
              />{{ $t("common.all") }}</label
            >
          </div>
          <div class="w-50 d-flex" v-if="!checkModelAll">
            <autocomplete
              :source="modelList"
              input-class="autocomplete-input mgt_seltype"
              ref="autocomplete"
              @selected="validateSelection"
              @results="getInputValue"
              placeholder="Search a Model"
              :disableInput="checkModelAll"
            >
            </autocomplete>
            <button
              type="button"
              class="tbl_add_bt"
              style="height: 34px; width: 34px"
              v-if="authModelAll || checkModelAll"
              @click="getTypeModel"
            >
              Add
            </button>
          </div>
          <div v-if="authModelList.length > 0" class="m-2">
            <div
              v-for="(model, index) in authModelList"
              :key="index"
              class="document_keyword"
              :id="'nm' + model.authValue"
            >
              {{ model.authValue }}
              <button
                type="button"
                @click="deleteTempModelAuth(model, index)"
                class="btn"
              >
                {{ $t("common.delete") }}
              </button>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button type="button" @click="getNewModelAuth" class="btn btn-primary">
          {{ $t("common.choose") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </NewModelModal>
  </section>
</template>

<script>
import $ from "jquery";
import { getCountrys } from "@/api/code";
import { documentMgmtList } from "@/api/document";
import {
  getUserDetail,
  saveUserDocAuth,
  saveUserDocDownloadAuth,
  initPassword,
  changeActiveFlag,
  updateUserDocumentauth,
  saveMgmtUser,
  goCheckId,
  deleteUser
} from "@/api/user";
import CommonModal from "@/components/modal/CommonModal";
import DocumentModal from "@/components/modal/DocumentModal";
import NewModelModal from "@/components/modal/NewModelModal";
import { validateEmail, validatePhone, checkPassword } from "@/utils/validation";
import Autocomplete from "vuejs-auto-complete";
export default {
  computed: {},

  components: {
    CommonModal,
    Autocomplete,
    NewModelModal,
    DocumentModal
  },
  data() {
    return {
      mem: { mobileTelCountry: "82", countryCode: "" },
      roleId: "",
      loginId: "",
      roleList: [],
      docTypeList: [],
      documentList: [],
      productList: [],
      prodSubList: [],
      prodSubNewList: [],
      modelList: [],
      exList: [],
      authProdList: [],
      authDocTypeList: [],
      authExhaustList: [],
      authDocumentList: [],
      authModelList: [],
      authPDFDownalodList : [],
      authAll: false,
      newAuth: [],
      newDownloadAuth : [],
      docAuthDetail: {
        authId: "",
        authType: "",
        authValue: "",
        authDiv: "",
        authName: "",
        crudType: "",
      },
      userRoleList: [],
      form: {
        page: 1,
        searchWord: "",
      },
      docForm: {
        doctypeId: "",
        prodId: "",
        userId: "",
        upperProdId: "",
        startDate: "",
        endDate: "",
        searchWord: "",
        searchState: "",
        publishedYN: "",
        lang: "",
      },
      pagingVO: "",
      mainProd: "",
      subProd: "",
      langList: "",
      subProductType: "",
      confirmYN: false,
      checkAll: false,
      docCheckAll: false,
      authProdAll: true,
      authDocTypeAll: true,
      authExhaustAll: true,
      authDocumentAll: true,
      authDocumentDownloadAll : true,
      authModelAll: true,
      tmpModalList: [],
      optionsShown: false,
      searchFilter: "",
      selected: "",
      checkModelAll: false,
      disabled: false,
      tmpValue: "",
      showProdModal: false,
      showDocModal: false,
      showExModal: false,
      showDocuModal: false,
      showDocDownloadModal : false,
      showModelModal: false,
      prodDisabled: false,
      checkDp: false,
      countrys: [],
      modelAllCheckbox : false
    };
  },
  methods: {
    reset() {
      this.mem = "";
      this.roleId = "";
      this.loginId = "";
      this.roleList = [];
      this.docTypeList = [];
      this.documentList = [];
      this.productList = [];
      this.prodSubList = [];
      this.prodSubNewList = [];
      this.modelList = [];
      this.exList = [];
      this.authProdList = [];
      this.authDocTypeList = [];
      this.authExhaustList = [];
      this.authDocumentList = [];
      this.authModelList = [];
      this.authPDFDownalodList = [];
      this.authAll = false;
      this.newAuth = [];
      this.newDownloadAuth = [];
      this.docAuthDetail = {};
      this.userRoleList = [];
      this.form = {};
      this.docForm = {};
      this.pagingVO = "";
      this.mainProd = "";
      this.subProd = "";
      this.langList = "";
      this.subProductType = "";
      this.confirmYN = false;
      this.checkAll = false;
      this.docCheckAll = false;
      this.authProdAll = true;
      this.authDocTypeAll = true;
      this.authExhaustAll = true;
      this.authDocumentAll = true;
      this.authDocumentDownloadAll = true;
      this.authModelAll = true;
      this.tmpModalList = [];
      this.optionsShown = false;
      this.searchFilter = "";
      this.selected = "";
      this.checkModelAll = false;
      this.disabled = false;
      this.tmpValue = "";
      this.showProdModal = false;
      this.showDocModal = false;
      this.showExModal = false;
      this.showDocuModal = false;
      this.showDocDownloadModal = false;
      this.showModelModal = false;
    },
    getTypeModel() {
      this.validateSelection({ display: this.tmpValue });
    },
    getInputValue() {
      this.tmpValue = $(".autocomplete-input").val();
      // 양쪽 공백 제거
      this.tmpValue = this.tmpValue.trim();
    },
    validateSelection(selection) {
      if (selection.display != null) {
        if (!this.authModelList.length > 0) {
          this.selected = selection.display;
        } else {
          for (let i in this.authModelList) {
            // 중복체크
            if (this.authModelList[i].authValue != selection.display) {
              this.selected = selection.display;
            } else {
              return;
            } // 중복시 alert 추가?
          }
        }
        this.authModelList.push({
          authId: "",
          authType: "model",
          authValue: this.selected,
          authDiv: "",
          authName: this.selected,
          crudType: "I",
        });
      }
    },
    deleteTempModelAuth(model, index) {
      this.authModelAll = true;
      if(model.authValue=='all'){
        this.checkModelAll = false;
        this.disabled = false;
        this.modelAllCheckbox = false;
        this.goCheckModelAll(false);
      }else{
        this.checkModelAll = false;
        this.disabled = false;
        $("#nm" + model.authValue).remove();
        $("#m" + model.authValue).remove();
        this.authModelList[index].crudType = "D";
      }
    },
    getDropdownValues(keyword) {
      keyword;
    },
    // Model 권한 all 선택했을때
    goCheckModelAll(checked) {
      this.checkModelAll = checked;
      if (checked) {
        for (let i in this.authModelList) {
          // this.deleteTempModelAuth(null, i);
          // this.deleteModelAuth(this.authModelList[i], i);
          $("#nm" + this.authModelList[i].authValue).remove();
          $("#m" + this.authModelList[i].authValue).remove();
          this.authModelList[i].crudType = "D";
        }
        this.authModelList.push({
          authId: "",
          authType: "model",
          authValue: "all",
          authDiv: "",
          authName: "All",
          crudType: "I",
        });
        this.validateSelection({ name: null, id: null });
      } else {
        for (let i in this.authModelList) {
          if(this.authModelList[i].authValue=='all'){
            $("#nm" + this.authModelList[i].authValue).remove();
            $("#m" + this.authModelList[i].authValue).remove();
            this.authModelList[i].crudType = "D";
          }
          // this.deleteTempModelAuth(null, i);
          // this.deleteModelAuth(this.authModelList[i], i);
        }
        this.authModelAll = true;
      }
    },
    // goCheckModelAll(checked) {
    //   this.checkModelAll = checked;
    //   if (checked) {
    //     for (let i in this.authModelList) {
    //       this.deleteTempModelAuth(null, i);
    //       this.deleteModelAuth(this.authModelList[i], i);
    //     }
    //     this.authModelList.push({
    //       authId: "",
    //       authType: "model",
    //       authValue: "all",
    //       authDiv: "",
    //       authName: "All",
    //       crudType: "I",
    //     });
    //     this.validateSelection({ name: null, id: null });
    //   } else {
    //     for (let i in this.authModelList) {
    //       this.deleteTempModelAuth(null, i);
    //       this.deleteModelAuth(this.authModelList[i], i);
    //     }
    //   }
    // },
    async fetchData() {
      let loader = this.$loading.show({});
      try {
        this.loginId = this.$route.params.loginId;
        const { data } = await getUserDetail(this.loginId);
        const response = await getCountrys();
        this.countrys = response.data.countrys;
        // 사용자 정보
        this.mem = data.member;
        if (this.mem.mobileTelCountry == null) {
          this.mem.mobileTelCountry = "";
        }
        // 문서 권한 분류
        this.roleList = data.member.roleList;
        for (let i in this.roleList) {
          this.roleList[i].userId = this.mem.userId;
          if (this.roleList[i].roleId.substring(0, 2) == "R_") {
            this.roleId = this.roleList[i].roleId;
          }
        }
        // docType 모달 setting
        this.docTypeList = data.docTypeList;
        this.docTypeList.unshift({ doctypeId: "all", doctypeName: "All" });
        // prodType 모달 setting
        this.productList = data.productList;
        this.productList.unshift({ prodId: "all", prodName: "All" });
        this.prodSubList = data.prodSubList;
        // 전체 문서 모달 setting
        // this.docFetchData(this.docForm);
        // Exhaust Certification 모달 setting
        this.exList = data.exList;
        this.exList.unshift({ exhaustCertiId: "all", exhaustCertiName: "All" });
        this.modelList = data.modelList;
        // 사용자 문서 권한
        this.authProdList = data.authProdList;
        if (this.authProdList.length > 0 && this.authProdList[0].authValue == "all") {
          this.authProdAll = false;
        }
        this.authDocTypeList = data.authDocTypeList;
        if (
          this.authDocTypeList.length > 0 &&
          this.authDocTypeList[0].authValue == "all"
        ) {
          this.authDocTypeAll = false;
        }
        this.authExhaustList = data.authExhaustList;
        if (
          this.authExhaustList.length > 0 &&
          this.authExhaustList[0].authValue == "all"
        ) {
          this.authExhaustAll = false;
        }
        this.authDocumentList = data.authDocumentList;
        if (
          this.authDocumentList.length > 0 &&
          this.authDocumentList[0].authValue == "all"
        ) {
          this.authDocumentAll = false;
        }
        this.authModelList = data.authModelList;
        this.modelAllCheckbox = false;
        if (this.authModelList.length > 0 && this.authModelList[0].authValue == "all") {
          this.authModelAll = false;
          this.modelAllCheckbox = true;
        }
        // Document PDF Download 권한
        this.authPDFDownalodList = data.pdfAuth;
        if (
          this.authPDFDownalodList.length > 0 &&
          this.authPDFDownalodList[0].docId == "all"
        ) {
          this.authPDFDownalodList[0].docTitle = "All";
          this.authDocumentDownloadAll = false;
        }
        loader.hide();
      } catch (error) {
        console.log(error);
        loader.hide();
      }
    },
    // 전체 문서 모달
    async docFetchData() {
      let loader = this.$loading.show({});
      try {
        const { data } = await documentMgmtList(this.docForm);
        this.documentList = data.docList;
        this.documentList.unshift({ doctypeName: "All", docId: "all", docTitle: "All" });
        // 기존 문서권한 selected
        for (let i in this.documentList) {
          for (let j in this.authPDFDownalodList) {
            if (this.documentList[i].docId === this.authPDFDownalodList[j].docId) {
              this.documentList[i].selected = true;
            }
          }
        }
        this.mainProd = data.mainProd;
        this.subProd = data.subProd;
        this.langList = data.langList;
        this.pagingVO = data.pagingVO;
        loader.hide();
      } catch (err) {
        console.log(err);
        loader.hide();
      }
    },
    searchPage(page) {
      // 페이지 클릭 시
      this.docForm.page = page;
      // this.$store.commit("setPage", page);
      this.docFetchData();
    },
    // 문서 검색
    searchDocBtn() {
      this.docFetchData();
    },
    // 대분류 선택시 중분류
    getSubProducts(prodId) {
      this.subProductType = [];
      for (let i in this.subProd) {
        if (prodId === this.subProd[i].upperProdId) {
          this.subProductType.push(this.subProd[i]);
        }
      }
    },
    closeModal() {
      this.showProdModal = false;
      this.showDocModal = false;
      this.showExModal = false;
      this.showDocuModal = false;
      this.showModelModal = false;
      this.showDocDownloadModal = false;
      this.reset();
      this.fetchData();
    },
    // (문서모달) 전체선택
    // goDocCheckAll(checked) {
    //   this.docCheckAll = checked;
    //   for (let i in this.documentList) {
    //     // if (i != 0) {
    //     //   $("#" + this.documentList[i].docId).hide();
    //     // }
    //     this.documentList[i].selected = this.docCheckAll;
    //     if (this.documentList[i].docTitle == "All") {
    //       this.documentList[i].selected = false;
    //     }
    //   }
    // },
    // (사용자모달) 전체선택
    goCheckAll(checked) {
      this.checkAll = checked;
      for (let i in this.userRoleList) {
        this.userRoleList[i].selected = this.checkAll;
      }
    },
    // role 검색
    searchBtn() {
      this.form.page = 1;
    },
    // searchPage(page) {
    //   // 페이지 클릭 시
    //   this.form.page = page;
    // },
    // 문서권한추가 모달 show
    addAuth(sort) {
      if (sort == "product") {
        // 기존 prodType selected
        for (let i in this.productList) {
          for (let j in this.authProdList) {
            if (this.productList[i].prodId === this.authProdList[j].authValue
                && this.authProdList[j].crudType!="D") {
              this.productList[i].selected = true;
            }
          }
        }
        this.showProdModal = true;
      } else if (sort == "documentType") {
        // 기존 docType selected
        for (let i in this.docTypeList) {
          for (let j in this.authDocTypeList) {
            if (this.docTypeList[i].doctypeId === this.authDocTypeList[j].authValue
                && this.authDocTypeList[j].crudType!="D") {
              this.docTypeList[i].selected = true;
            }
          }
        }
        this.showDocModal = true;
      } else if (sort == "exhaust") {
        // 기존 ExhaustCerti selected
        for (let i in this.exList) {
          for (let j in this.authExhaustList) {
            if (this.exList[i].exhaustCertiId === this.authExhaustList[j].authValue
                && this.authExhaustList[j].crudType!="D") {
              this.exList[i].selected = true;
            }
          }
        }
        this.showExModal = true;
      // } else if (sort == "document") {
        // this.showDocuModal = true;
      } else if (sort == "model") {
        this.showModelModal = true;
      }
    },
    // 문서 다운로드 권한 추가 Modal
    addDocDownloadAuthModal(){
      // 기존 선택된 문서 selected
      // for (let i in this.documentList) {
      //     for (let j in this.authPDFDownalodList) {
      //       if (this.documentList[i].docId === this.authPDFDownalodList[j].authValue) {
      //         this.documentList[i].selected = true;
      //       }
      //     }
      //   }
      this.docFetchData();
      this.showDocDownloadModal = true;
    },
    // Sub ProdType 세팅
    getSubProd(prodId) {
      this.prodSubNewList = [];
      for (let i = 0; i < this.prodSubList.length; i++) {
        if (this.prodSubList[i].upperProdId == prodId) {
          this.prodSubNewList.push(this.prodSubList[i]);
        }
      }
      // 기존 Sub Prodtype selected 
      for (let i in this.prodSubNewList) {
          for (let j in this.authProdList) {
            if (this.prodSubNewList[i].prodId === this.authProdList[j].authValue
                && this.authProdList[j].crudType!="D") {
              this.prodSubNewList[i].selected = true;
            }
          }
      }

    },
    // prod all 일때 초기화
    resetProdSubList(prodName, result) {
      if (prodName == "All" && !result) {
        for (let i in this.productList) {
          if (i != 0) {
            $("#" + this.productList[i].prodId).hide();
          }
        }
        $("#prodSub").hide();
      } else {
        for (let i in this.productList) {
          if (i != 0) {
            $("#" + this.productList[i].prodId).show();
          }
        }
        $("#prodSub").show();
      }
      this.prodSubNewList = [];
    },
    // doctype all 일때 초기화
    resetDocTypeList(docTypeName, result) {
      if (docTypeName == "All" && !result) {
        for (let i in this.docTypeList) {
          if (i != 0) {
            $("#" + this.docTypeList[i].doctypeId).hide();
          }
        }
      } else {
        for (let i in this.docTypeList) {
          if (i != 0) {
            $("#" + this.docTypeList[i].doctypeId).show();
          }
        }
      }
    },
    // exhaust all 일때 초기화
    resetExhaustCertiList(exhaustCertiName, result) {
      if (exhaustCertiName == "All" && !result) {
        for (let i in this.exList) {
          if (this.exList[i].exhaustCertiName != "All") {
            $("#" + this.exList[i].exhaustCertiId).hide();
          }
        }
      } else {
        for (let i in this.exList) {
          if (this.exList[i].exhaustCertiName != "All") {
            $("#" + this.exList[i].exhaustCertiId).show();
          }
        }
      }
    },
    // document all 일때 초기화
    resetDocumentList(docTitle, result) {
      if (docTitle == "All" && !result) {
        for (let i in this.documentList) {
          if (this.documentList[i].docTitle != "All") {
            this.documentList[i].selected = false;
            $("#" + this.documentList[i].docId + this.documentList[i].modelcodeId).hide();
          } else {
            this.documentList[i].selected = true;
          }
        }
      } else {
        for (let i in this.documentList) {
          if (this.documentList[i].docTitle != "All") {
            $("#" + this.documentList[i].docId + this.documentList[i].modelcodeId).show();
          } else {
            this.documentList[i].selected = false;
          }
        }
      }
    },
    // 선택한 prod 권한 추가
    getNewProdAuth() {
      //대분류 추가
      if (this.authProdList == null || this.authProdList.length < 0) {
        this.authProdList = [];
      }
      for (let i in this.productList) {
        if (this.productList[i].selected) {
          // 중복 확인
          for (let j in this.authProdList) {
            if(this.productList[i].prodId === this.authProdList[j].authValue
                && this.authProdList[j].crudType != "D"){
                this.productList[i].duplicate = true;
                break;
            }
          }
          if(!this.productList[i].duplicate){
            
            this.authProdList.push({
                authId: "",
                authType: "product",
                authValue: this.productList[i].prodId,
                authDiv: "",
                authName: this.productList[i].prodName,
                crudType: "I",
              });
          }
          this.productList[i].selected = false;

          // All 확인
          if (this.productList[i].prodId == "all") {
            // 기존 Auth List 삭제
            for (let j in this.authProdList) {
              if(this.authProdList[j].authValue!='all'){
                $("#p"+this.authProdList[j].authValue).remove();
                this.authProdList[j].crudType = "D";
              }
            }
            this.authProdAll = false;
            break;
          } 
        }
      }
      //중분류 추가
      if(this.authProdAll){
        for (let i in this.prodSubNewList) {
          if (this.prodSubNewList[i].selected) {
            for (let j in this.authProdList) {
              if(this.prodSubNewList[i].prodId === this.authProdList[j].authValue){
                this.prodSubNewList[i].duplicate = true;
                break;
              }
            }
            if(!this.prodSubNewList[i].duplicate){
              this.authProdList.push({
                authId: "",
                authType: "product",
                authValue: this.prodSubNewList[i].prodId,
                authDiv: "",
                authName: this.prodSubNewList[i].prodName,
                crudType: "I",
              });
            }
            this.prodSubNewList[i].selected = false;
          }
        }
      }
      
      this.showProdModal = false;
    },
    // 선택한 docType 추가
    getNewDocTypeAuth() {
      for (let i in this.docTypeList) {
        if (this.docTypeList[i].selected) {
          
          // 중복 확인
          for (let j in this.authDocTypeList) {
            if(this.docTypeList[i].doctypeId === this.authDocTypeList[j].authValue
                && this.authDocTypeList[j].crudType != "D"){
                this.docTypeList[i].duplicate = true;
                break;
            }
          }
          if(!this.docTypeList[i].duplicate){
            this.authDocTypeList.push({
              authId: "",
              authType: "doctype",
              authValue: this.docTypeList[i].doctypeId,
              authDiv: "",
              authName: this.docTypeList[i].doctypeName,
              crudType: "I",
            });
          }
          
          this.docTypeList[i].selected = false;
          // All 확인
          if (this.docTypeList[i].doctypeName == "All") {
            // 기존 Auth List 삭제
            for (let j in this.authDocTypeList) {
              if(this.authDocTypeList[j].authValue!='all'){
                $("#dt"+this.authDocTypeList[j].authValue).remove();
                this.authDocTypeList[j].crudType = "D";
              }
            }
            // doctype auth 가 all 임
            this.authDocTypeAll = false;

            break;
          }
        }
      }
      this.showDocModal = false;
    },
    //선택한 배기인증 추가
    getNewExhauseAuth() {
      for (let i in this.exList) {
        if (this.exList[i].selected) {
          // 중복 확인
          for (let j in this.authExhaustList) {
            if(this.exList[i].exhaustCertiId === this.authExhaustList[j].authValue
              && this.authExhaustList[j].crudType != "D"){
              this.exList[i].duplicate = true;
              break;
            }
          }
          if(!this.exList[i].duplicate){
            this.authExhaustList.push({
              authId: "",
              authType: "exhaust",
              authValue: this.exList[i].exhaustCertiId,
              authDiv: "",
              authName: this.exList[i].exhaustCertiName,
              crudType: "I",
            });
          }
          this.exList[i].selected = false;
          // All 확인
          if (this.exList[i].exhaustCertiName == "All") {
            // 기존 Auth List 삭제
            for (let j in this.authExhaustList) {
              if(this.authExhaustList[j].authValue!='all'){
                $("#e"+this.authExhaustList[j].authValue).remove();
                this.authExhaustList[j].crudType = "D";
              }
            }
            this.authExhaustAll = false;
            break;
          }
        }
      }
      this.showExModal = false;
    },
    //선택한 문서 권한 추가
    // getNewDocumentAuth() {
    //   for (let i in this.documentList) {
    //     if (this.documentList[i].selected) {
    //       // All 확인
    //       if (this.documentList[i].docTitle == "All") {
    //         this.authDocumentAll = false;
    //       }
    //       this.authDocumentList.push({
    //         authId: "",
    //         authType: "document",
    //         authValue: this.documentList[i].docId,
    //         authDiv: "",
    //         authName: this.documentList[i].docTitle,
    //         crudType: "I",
    //       });
    //       this.documentList[i].selected = false;
    //     }
    //   }
    //   this.showDocuModal = false;
    // },
    //선택한 문서 다운로드 권한 추가
    getNewDocumentDownloadAuth() {
      for (let i in this.documentList) {
        if (this.documentList[i].selected) {
          // 중복 확인
          for (let j in this.authPDFDownalodList) {
            if(this.documentList[i].docId === this.authPDFDownalodList[j].docId
              && this.authPDFDownalodList[j].crudType != "D"){
              this.documentList[i].duplicate = true;
              break;
            }
          }
          if(!this.documentList[i].duplicate){
            this.authPDFDownalodList.push({
              userId: this.mem.userId,
              docId: this.documentList[i].docId,
              docTitle: this.documentList[i].docTitle,
              periodYn : "N",
              crudType: "I",
            });
          }
          this.documentList[i].selected = false;

          // All 확인
          if (this.documentList[i].docTitle == "All") {
            this.documentList[i].docId = "all";
            // 기존 Auth List 삭제
            for (let j in this.authPDFDownalodList) {
              if(this.authPDFDownalodList[j].docId!='all'){
                $("#d"+this.authPDFDownalodList[j].docId).remove();
                this.authPDFDownalodList[j].crudType = "D";
              }
            }
            this.authDocumentDownloadAll = false;
            break;
          }
        }
      }
      this.showDocDownloadModal = false;
    },
    //선택한 모델 권한 추가
    getNewModelAuth() {
      for (let i in this.authModelList) {
        if (this.authModelList[i].authName == "All") {
          this.checkModelAll = true;
          this.authModelAll = false;
        }
      }
      this.showModelModal = false;

    },
    //선택한 제품 권한 삭제
    deleteProdAuth(prod, index) {
      // $("#p" + index).remove();
      this.authProdList[index].crudType = "D";
      this.saveNewAuth("delete");
    },
    //선택한 문서타입 권한 삭제
    deleteDocTypeAuth(doc, index) {
      // $("#dt" + doc.authValue).remove();
      this.authDocTypeList[index].crudType = "D";
      this.saveNewAuth("delete");
    },
    //선택한 배기인증 권한 삭제
    deleteExhaustAuth(ex, index) {
      // $("#e" + ex.authValue).remove();
      this.authExhaustList[index].crudType = "D";
      this.saveNewAuth("delete");
    },
    // //선택한 문서 권한 삭제
    // deleteDocumentAuth(doc, index) {
    //   $("#d" + doc.authValue).remove();
    //   this.authDocumentList[index].crudType = "D";
    // },
    //선택한 모델 권한 삭제
    deleteModelAuth(model, index) {
      // $("#m" + model.authValue).remove();
      // $("#m" + index).remove();
      this.authModelList[index].crudType = "D";
      this.saveNewAuth("delete");
    },
    // 선택한 문서 Download 권한 삭제
    deleteDocDownloadAuth(doc, index){
      // $("#d"+doc.docId).remove();
      this.authPDFDownalodList[index].crudType = "D";
      this.saveNewDownloadAuth("delete");
    },
    //새로운 문서권한 저장
    async saveNewAuth(type) {
      if (this.roleId == "") {
        alert(this.$t("alert.noAuthorityToAdd"));
        return;
      }
      try {
        for (let i in this.authProdList) {
          this.authProdList[i].userId = this.mem.userId;
          this.newAuth.push(this.authProdList[i]);
        }
        for (let i in this.authDocTypeList) {
          this.authDocTypeList[i].userId = this.mem.userId;
          this.newAuth.push(this.authDocTypeList[i]);
        }
        for (let i in this.authExhaustList) {
          this.authExhaustList[i].userId = this.mem.userId;
          this.newAuth.push(this.authExhaustList[i]);
        }
        for (let i in this.authDocumentList) {
          this.authDocumentList[i].userId = this.mem.userId;
          this.newAuth.push(this.authDocumentList[i]);
        }
        for (let i in this.authModelList) {
          this.authModelList[i].userId = this.mem.userId;
          this.newAuth.push(this.authModelList[i]);
        }
        const { data } = await saveUserDocAuth(this.newAuth);
        if (data.status) {
          if("delete" === type){
            alert(this.$t("alert.deletedSuccessfully"));
          }else{
            alert(this.$t("alert.changedSuccessfully"));
          }
          this.reset();
          this.fetchData();
          this.checkModelAll = false;
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (err) {
        console.log(err);
      }
    },
    //새로운 문서 다운로드 권한 저장
    async saveNewDownloadAuth(type) {
      try {
        for (let i in this.authPDFDownalodList) {
          this.authPDFDownalodList[i].userId = this.mem.userId;
          this.newDownloadAuth.push(this.authPDFDownalodList[i]);
        }
        const { data } = await saveUserDocDownloadAuth(this.newDownloadAuth);
        if (data.status) {
          if("delete"===type){
            alert(this.$t("alert.deletedSuccessfully"));
          }else{
            alert(this.$t("alert.changedSuccessfully"));
          }
          this.reset();
          this.fetchData();
          this.checkModelAll = false;
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (err) {
        console.log(err);
      }
    },
    //비밀번호 초기화
    async initPassword() {
      this.confirmYN = confirm(this.$t("alert.reset"));
      if (this.confirmYN) {
        try {
          const { data } = await initPassword(this.mem);
          if (data.status) {
            alert(this.$t("alert.passwordHasBeenReset"));
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        return;
      }
    },
    // 승인
    async approveUser() {
      this.confirmYN = confirm(this.$t("alert.approve"));
      if (this.confirmYN) {
        try {
          this.mem.activeFlag = "1";
          const { data } = await changeActiveFlag(this.mem);
          if (data.status) {
            alert(this.$t("alert.processingIsComplete"));
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        return;
      }
    },
    // 반환
    async disApproveUser() {
      this.confirmYN = confirm(this.$t("alert.reject"));
      if (this.confirmYN) {
        try {
          this.mem.activeFlag = "0";
          const { data } = await changeActiveFlag(this.mem);
          if (data.status) {
            alert(this.$t("alert.processingIsComplete"));
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        return;
      }
    },
    // 유저 정보수정/ 유저 Doc 권한 수정
    async saveUserDocumentauth() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      this.confirmYN = confirm(this.$t("alert.save"));

      if (this.confirmYN) {
        try {
          const { data } = await updateUserDocumentauth(this.mem);
          if (data.status) {
            alert(this.$t("alert.savedSuccessfully"));
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        return;
      }
    },
    // 신규 회원 저장
    async saveNewUser() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      if (!this.checkDp) return alert(this.$t("alert.pleaseChecktheIDduplicate"));
      if (!confirm(this.$t("alert.save"))) return;
      // this.mem.loginId = this.user.email1 + "@" + this.user.email2;
      this.checkEmail = validateEmail(this.mem.loginId);
      if (!this.checkEmail) return alert(this.$t("alert.checkTheEmail"));
      if (!validatePhone(this.mem.mobileTelNo))
        return alert(this.$t("alert.checkThePhoneNumberWithFormat"));
      if (!checkPassword(this.mem.password))
        return alert(this.$t("alert.checkThePasswordWithFormat"));
      try {
        // 중복 최종 체크
        const response1 = await goCheckId(this.mem);
        if (response1.data.loginUser != null) {
          alert(this.$t("alert.alreadyExist"));
          return;
        }
        const { data } = await saveMgmtUser(this.mem);
        if (data.status) {
          alert(this.$t("alert.savedSuccessfully"));
          this.$router.push({ name: "userMgmt" });
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 사용자 삭제
    async deleteUser() {
      if (!confirm(this.$t("alert.delete"))) return;
      try {
        this.mem.deleted = "1";
        const { data } = await deleteUser(this.mem);
        if (data.status) {
          alert(this.$t("alert.deletedSuccessfully"));
          this.$router.push({ name: "userMgmt" });
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (error) {
        console.log(error);
      }
    },
    // id 중복체크
    async checkDuplicate() {
      this.checkEmail = validateEmail(this.mem.loginId);
      try {
        const { data } = await goCheckId(this.mem);
        if (data.loginUser != null) {
          this.checkDp = false;
          alert(this.$t("alert.alreadyExist"));
          return;
        }
        this.checkDp = true;
        alert(this.$t("alert.youCanUseThisID"));
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    if (this.$route.params.loginId != undefined) {
      this.fetchData();
    } else {
      $(".allowDoc").hide();
    }
  },
};
</script>

<style scoped>
.bt_box{
  text-align: right;
  margin-bottom: 10px;
  width: 100%;
}
.sm_delete{
  width: 100px;
}
.auth_btn{
  margin :5px;
  height: 36px;
  padding-bottom: 5px;
}
</style>
